import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { msg } from 'api';

export default class NotFound extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  static renderHeading() {
    const { notFound: { heading } } = msg;

    if (!heading) {
      return null;
    }

    return (
      <p className="nf-resourceNotFound__heading">{heading}</p>
    );
  }

  render() {
    const { children } = this.props;
    const description = React.Children.map(children, child =>
      <div className="nf-resourceNotFound__text">{child}</div>
    );

    return (
      <div className="nf-resourceNotFound">
        <div className="nf-resourceNotFound__image" />
        {NotFound.renderHeading()}
        {description}
        <p className="nf-resourceNotFound__buttonWrapper">
          <Link
            className="nf-resourceNotFound__button"
            to="/"
          >
            Go to homepage
          </Link>
        </p>
      </div>
    );
  }
}
